exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subFooterLogo{\r\n    width: 210px;\r\n    height: 25px;\r\n}\r\n\r\n.subFooterLogoText{\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n}\r\n\r\n.subFooterListHeader{\r\n    font-size: 15px;\r\n    font-weight: 700;\r\n}\r\n\r\n.subFooterList{\r\n    font-size: 14px;\r\n    list-style-type: none;\r\n}\r\n\r\n.subFooterList li a {\r\n    color: #6c757d !important;\r\n}\r\n\r\n.subFooterList li a:hover {\r\n    color: rgb(191, 124, 121) !important;\r\n}\r\n", ""]);

// exports
